ANONYMOUS_PLAN_SKUS_FOURTEEN_MONTHS